export default __webpack_public_path__ + "static/media/micimg2.1cb043f2.webp";